const SSO_REF_KEY = 'sso_ref_param';
const SSO_REF_PENDING_KEY = 'sso_ref_pending';
const SSO_REF_PENDING_AT_KEY = 'sso_ref_pending_at';
const SSO_REF_PENDING_MAX_AGE_MS = 30 * 60 * 1000;

export function resolveRefParameter(routeRef = '') {
  const urlRef = typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get('ref')
    : '';
  const currentRef = urlRef || (typeof routeRef === 'string' ? routeRef : '');

  if (currentRef) {
    localStorage.setItem(SSO_REF_KEY, currentRef);
    localStorage.removeItem(SSO_REF_PENDING_KEY);
    localStorage.removeItem(SSO_REF_PENDING_AT_KEY);
    return currentRef;
  }

  const pendingAt = Number(localStorage.getItem(SSO_REF_PENDING_AT_KEY));
  const isSsoCallbackPending = localStorage.getItem(SSO_REF_PENDING_KEY) === 'true'
    && Number.isFinite(pendingAt)
    && Date.now() - pendingAt <= SSO_REF_PENDING_MAX_AGE_MS;
  const pendingRef = isSsoCallbackPending ? localStorage.getItem(SSO_REF_KEY) || '' : '';
  localStorage.removeItem(SSO_REF_PENDING_KEY);
  localStorage.removeItem(SSO_REF_PENDING_AT_KEY);

  if (pendingRef) {
    return pendingRef;
  }

  localStorage.removeItem(SSO_REF_KEY);
  localStorage.removeItem('register_ref_param');
  return '';
}

export function preserveRefForSso(ref) {
  if (ref) {
    localStorage.setItem(SSO_REF_KEY, ref);
    localStorage.setItem(SSO_REF_PENDING_KEY, 'true');
    localStorage.setItem(SSO_REF_PENDING_AT_KEY, String(Date.now()));
    return;
  }

  localStorage.removeItem(SSO_REF_KEY);
  localStorage.removeItem(SSO_REF_PENDING_KEY);
  localStorage.removeItem(SSO_REF_PENDING_AT_KEY);
}

export function clearRefContext() {
  localStorage.removeItem(SSO_REF_KEY);
  localStorage.removeItem(SSO_REF_PENDING_KEY);
  localStorage.removeItem(SSO_REF_PENDING_AT_KEY);
  localStorage.removeItem('register_ref_param');
}
